import Grid from './Grid'

export default Grid('layout')
